class Account {
  constructor() {
    this.vars = window.statelyVars || {};

    this.accountPage = '/account';
    this.styleDropsPage = this.accountPage + '?view=style-drops';

    this.isLoggedIn = this.vars.customer?.id || false;

    this.init();
  }

  init() {
    if (this.isLoggedIn && this.vars.page.handle === 'login') {
      this.handleRedirect();
    }
    window.addEventListener('DOMContentLoaded', () => {
      if (this.isLoggedIn) {
        this.initMenuLinks();
      } else {
        this.checkMultipass();
      }
    });
  }

  isMobile() {
    return window.innerWidth < 1200;
  }

  handleRedirect() {
    document.getElementById('MainContent').style.display = 'none';
    const searchParams = new URLSearchParams(window.location.search);
    let redirect = searchParams.get('checkout_url') ? searchParams.get('checkout_url') : (searchParams.get('return_to') ? searchParams.get('return_to') : this.accountPage);
    redirect = redirect.startsWith('/') ? redirect : '/' + redirect;
    redirect = window.location.origin + redirect;
    window.location.href = redirect;
  }

  initMenuLinks() {
    document.querySelectorAll('#account-nav .menu-item a').forEach(link => {
      if ((window.location.href.indexOf(link.href) !== -1 && link.href.indexOf(window.location.search) !== -1)) {
        link.closest('li').classList.add('selected');
      }
    });

    const navMenu = document.getElementById('account-nav');
    navMenu.addEventListener('click', () => {
      if (this.isMobile()) {
        navMenu.classList.toggle('active');
        document.body.classList.toggle('nav-open');
      }
    });

    document.body.addEventListener('click', (e) => {
      if (!this.isMobile() || !navMenu.classList.contains('active')) {
        return;
      }
      if (!navMenu.contains(e.target) && !e.target.closest('#account-nav')) {
        navMenu.classList.remove('active');
        document.body.classList.remove('nav-open');
      }
    });
  }

  checkMultipass ()
  {
    if (document.body.classList.contains('template-customers-login') && window.location.search.indexOf('multipass') !== -1) {
      const $html = $(`<div class="multipass-login">
        <h3 style="text-align: center; padding: 0 1rem 3rem; font-size: 32px;">Multipass Login</h3>
        <div class="field">
          <input type="email" name="multipass[email]" aria-label="email" id="multipassEmail" placeholder="Email" required="required" />
        </div>
        <div class="field">
          <input type="password" value="" id="multipassPassword" name="multipass[password]" aria-label="password" placeholder="Password" required="required" />
        </div>
        <button class="button">Sign In</button>
        </div>`);

      $html.find('button').on('click', (e) => {
        e.preventDefault();
        const url = window.statelyVars.api.public + '/customer/multipass';
        $.get(url, {
          email: $html.find('[name="multipass[email]"]').val(),
          password: $html.find('[name="multipass[password]"]').val()
        }).done(result => {
          console.log(result);
          if (!result.success) {
            return alert('Error: ' + result.error);
          }
          window.location.href = '/account/login/multipass/' + result.data.token;
        });
      });

      $('.login').html($html);
    }
  }
  
}

window.stately = window.stately || {};
window.stately.account = new Account();